import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

const CartContext = createContext();

const STORAGE_KEY = 'openps_cart';

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; } catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }, [items]);

  const addItem = useCallback((game) => {
    setItems(prev => {
      const id = game.id || game.sony_id;
      if (prev.find(i => (i.id || i.sony_id) === id)) return prev;
      return [...prev, game];
    });
  }, []);

  const removeItem = useCallback((gameId) => {
    setItems(prev => prev.filter(i => (i.id || i.sony_id) !== gameId));
  }, []);

  const clearCart = useCallback(() => setItems([]), []);

  const isInCart = useCallback((gameId) => {
    return items.some(i => (i.id || i.sony_id) === gameId);
  }, [items]);

  return (
    <CartContext.Provider value={{ items, addItem, removeItem, clearCart, isInCart, count: items.length }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
